export const CODE_OK = 0;

export const V3 = 'v3';

// google captcha key
export const GOOGLE_CAPTCHA_KEY = 'g-recaptcha-response';
export const CAPTCHA_NONE = 0;
export const CAPTCHA_ORIGIN = 1;
export const CAPTCHA_GOOGLE_V2 = 2;
export const CAPTCHA_GOOGLE_INVISIBLE = 3;

// page
export const DEFAULT_PAGE_SIZE = 50;
export const X_PAGINATION_CURRENT_PAGE = 'x-pagination-current-page';
export const X_PAGINATION_LIMIT = 'x-pagination-limit';
export const X_PAGINATION_TOTAL_COUNT = 'x-pagination-total-count';
export const X_PAGINATION_TOTAL_PAGES = 'x-pagination-total-pages';


export const BUS_ONLINE_STATUS_COLOR = {
    // The online status of main device installed on bus, 1: <= 5min, 2: (5,10], 3: (10, 15], 4: Others
    1: 'active',
    2: 'yellow',
    3: 'inactive',
    4: 'idle',
    5: 'unknown',
}
export const BUS_ONLINE_STATUS_TEXT = {
    // The online status of main device installed on bus, 1: <= 5min, 2: (5,10], 3: (10, 15], 4: Others
    1: 'Within 5 minutes',
    2: 'Between 5 to 10 minutes',
    3: 'Between 10 to 15 minutes',
    4: 'Between 15 to 30 minutes',
    5: 'More than 30 minutes or Unknown',
}

export const COMMON_STATUS = {
    //  1: Active, 2: Inactive, 3: Archived
    1: 'active',
    2: 'inactive',
    3: 'archived'
}

export const COMMON_STATUS_ACTIVE = '1';
export const COMMON_STATUS_INACTIVE = '2';
export const COMMON_STATUS_ARCHIVED = '3';

export const COMMON_STATUS_TABS = [
    {value: '0', label: 'All'},
    {value: COMMON_STATUS_ACTIVE, label: 'Active'},
    {value: COMMON_STATUS_INACTIVE, label: 'Inactive'},
    {value: COMMON_STATUS_ARCHIVED, label: 'Archived'}
]

export const MAP_API_KEY = 'AIzaSyCx_EBuDvCo0IazffXAaMVYR1vq9RDWKM4';


export const MAP_OPTIONS_CIRCLE_STOP = {
    strokeColor: '#f6b4b6',
    strokeOpacity: 0.1,
    strokeWeight: 1,
    fillColor: '#f6b4b6',
    fillOpacity: 0.25,
    zIndex: 2
}

export const MAP_OPTIONS_CIRCLE_ACTUAL = {
    strokeColor: '#0072bc',
    strokeOpacity: 0.8,
    strokeWeight: 1,
    fillColor: '#0072bc',
    fillOpacity: 0.75,
    zIndex:4 // manual actual reach stop, zIndex=4
}

export const MAP_OPTIONS_CIRCLE_AUTO = {
    strokeColor: '#5600bc',
    strokeOpacity: 0.8,
    strokeWeight: 1,
    fillColor: '#5600bc',
    fillOpacity: 0.75,
    zIndex:4 // auto actual reach stop, zIndex=4
}

export const MAP_OPTIONS_CIRCLE_OFFLINE_REACH_STOP = {
    strokeColor: '#673ab7',
    strokeOpacity: 0.8,
    strokeWeight: 1,
    fillColor: '#673ab7',
    fillOpacity: 0.75,
    zIndex:4 // actual offline reach stop, zIndex=4
}

export const MAP_OPTIONS_CIRCLE_REALTIME = {
    strokeColor: '#FF0000',
    strokeOpacity: 0.8,
    strokeWeight: 2,
    fillColor: '#FF0000',
    fillOpacity: 0.75,
    zIndex: 3
}

export const MAP_OPTIONS_CIRCLE_OFFLINE = {
    strokeColor: '#666666',
    strokeOpacity: 0.8,
    strokeWeight: 2,
    fillColor: '#666666',
    fillOpacity: 0.75,
    zIndex: 3
}

export const MAP_OPTIONS_CIRCLE_GUIDANCE = {
    strokeColor: '#007FFF',
    strokeOpacity: 1,
    strokeWeight: 2,
    fillColor: '#FFF',
    fillOpacity: 0.75,
    radius: 10,
    zIndex: 10
}

export const MAP_OPTIONS_CIRCLE_OVER_SPEED_OFFLINE = {
    strokeColor: '#600101',
    strokeOpacity: 1,
    strokeWeight: 3,
    fillColor: '#666666',
    fillOpacity: 0.75,
    zIndex: 3
}

export const MAP_OPTIONS_CIRCLE_OVER_SPEED_REALTIME = {
    strokeColor: '#600101',
    strokeOpacity: 1,
    strokeWeight: 3,
    fillColor: '#FF0000',
    fillOpacity: 0.75,
    zIndex: 3
}

export const MAP_OPTIONS_CIRCLE_OVER_SPEED_ACTUAL = {
    strokeColor: '#600101',
    strokeOpacity: 1,
    strokeWeight: 3,
    fillColor: '#0072bc',
    fillOpacity: 0.75,
    zIndex: 3
}


export const MAP_OPTIONS_POLYLINE_GUIDANCE = {
    strokeColor: '#007FFF',
    strokeWeight: 2,
    strokeOpacity: 1,
    zIndex: 1
}

export const MAP_OPTIONS_POLYLINE_FENCE = {
    strokeColor: '#FF0000',
    strokeOpacity: 0.8,
    strokeWeight: 2,
    fillColor: '#FF0000',
    fillOpacity: 0.35
}

export const GENDERS = [
    {value: '1', label: 'Male', alias: 'M'},
    {value: '2', label: 'Female', alias: 'F'},
    {value: '3', label: 'Unknown', alias: 'Unknown'}
]

export const MUST_BE_METS = [
    {value: '1', label: 'Yes'},
    {value: '2', label: 'No'}
]

export const TAG_STATUS = [
    {value: '1', label: 'In Use'},
    {value: '2', label: 'Lost'}
]

export const RELATIONSHIP = [
    {value: '1', label: 'Managed'},
    {value: '2', label: 'Contracted'}
]

export const DATA_ACCESS_DISTRICT = 1;
export const DATA_ACCESS_SCHOOL = 2;
export const DATA_ACCESS_TRANSPORTER = 3;

export const OPEN_STATUS = [
    {value: '1', label: 'Open'},
    {value: '2', label: 'Close'},
]

export const ENABLE_STATUS = [
    {value: '1', label: 'Enabled'},
    {value: '2', label: 'Disabled'},
]

export const VISIBLE_STATUS = [
    {value: '1', label: 'Visible'},
    {value: '2', label: 'Invisible'},
]

export const ROUTE_ACCESS = [
    {value: '1', label: 'Device Scope'},
    {value: '2', label: 'Driver Scope'},
    {value: '3', label: 'Transporter Scope'},
]

export const CICO_SCOPE = [
    {value: '1', label: 'Require cico in scheduled stop'},
    {value: '2', label: 'Allow cico in non-scheduled stop'},
    {value: '3', label: 'Allow cico in non-scheduled route'},
]

export const CICO_LOCATION = [
    {value: '1', label: 'Require cico in stop radius'},
    {value: '2', label: 'Allow cico out of stop radius'},
]

export const INSPECTION = [
    {value: '1', label: 'Treker Driver App'},
    {value: '2', label: 'GeoTab Drive App'},
]

export const EMERGENCY_PENDING = '1';
export const EMERGENCY_RESOLVED = '2';

export const EMERGENCY_STATUS = [
    {value: EMERGENCY_PENDING, label: 'Pending', code: 'pending'},
    {value: EMERGENCY_RESOLVED, label: 'Resolved', code: 'resolved'},
]


export const EXPIRED_STATUS_NORMAL = '1';
export const EXPIRED_STATUS_EXPIRED = '2';
export const EXPIRED_STATUS = [
    {value: EXPIRED_STATUS_NORMAL, label: 'Normal'},
    {value: EXPIRED_STATUS_EXPIRED, label: 'Expired'},
]


export const TRIP_STATUS_SCHEDULED = '1';
export const TRIP_STATUS_ACCEPTED = '2';
export const TRIP_STATUS_RUNNING = '3';
export const TRIP_STATUS_ARRIVAL = '4';
export const TRIP_STATUS_ENDED = '5';

export const TRIP_STATUS = [
    {value: TRIP_STATUS_SCHEDULED, label: 'Scheduled'},
    {value: TRIP_STATUS_ACCEPTED, label: 'Accepted'},
    {value: TRIP_STATUS_RUNNING, label: 'Running'},
    {value: TRIP_STATUS_ARRIVAL, label: 'Arrival'},
    {value: TRIP_STATUS_ENDED, label: 'Ended'},
]
export const TRIP_STATUS_COLOR = {
    1: 'scheduled',
    2: 'accepted',
    3: 'running',
    4: 'arrival',
    5: 'completed'
}

export const TRIP_ONTIME_NORMAL = '1';
export const TRIP_ONTIME_LATE = '2';
export const TRIP_ONTIME_VERY_LATE = '3';

export const STOP_ENTER = '1';
export const STOP_REACH = '2';
export const STOP_LEAVE = '3';


export const TRIGGER_TYPE = [
    {value: '1', label: 'Manual'},
    {value: '2', label: 'Auto'},
]


export const CICO_TYPES = {
    '1': 'Manual', 
    '2': 'RFID', 
    '3': 'NFC Card', 
    '4': 'NFC Device', 
    '5': 'QR Code', 
    '6': 'Active QR', 
    '7': 'FOB', 
    '8': 'Face ID',
    '9': 'Bar Code',
}

export const CICO_TYPE_ICON_MAPPING = {
    '1': 'manual', 
    '2': 'fob', 
    '3': 'fob', 
    '4': 'fob', 
    '5': 'qr', 
    '6': 'scan', 
    '7': 'fob', 
    '8': 'face',
    '9': 'bar',
}

export const PICKUP = '1';
export const DROPOFF = '2';


// eventType, 1: Trip Event, 2: Stop Event, 3: Sched Pudo Event, 4: Unsched Pudo Event, 5: Waypoint, 6: Estimation
export const TRIP_EVENT = '1'
export const STOP_EVENT = '2'
export const SCHED_PUDO_EVENT = '3'
export const UN_SCHED_PUDO_EVENT = '4'
export const WAYPOINT_EVENT = '5'
export const ESTIMATION_EVENT = '6'
export const EMERGENCY_EVENT = '99' // fake

export const PUBLISH_STATUS_DRAFT = '1';
export const PUBLISH_STATUS_PUBLISH = '2';
export const PUBLISH_STATUS_UNPUBLISH = '3';
export const PUBLISH_STATUS_COLOR = {
    1: 'scheduled',
    2: 'active',
    3: 'inactive',
}
export const PUBLISH_STATUS = [
    {value: PUBLISH_STATUS_DRAFT, label: 'Draft', status: 'scheduled'},
    {value: PUBLISH_STATUS_PUBLISH, label: 'Published', status: 'active'},
    {value: PUBLISH_STATUS_UNPUBLISH, label: 'Unpublished', status: 'inactive'},
]

export const SIGNATURE_REQUIRED = [
    {value: '1', label: 'Required'},
    {value: '2', label: 'Optional'},
]

export const YES_OR_NO = [
    {value: '1', label: 'Yes'},
    {value: '2', label: 'No'},
]

// Inspection defect status
export const INSPECTION_DEFECT_NONE = 1
export const INSPECTION_DEFECT_PASS = 2
export const INSPECTION_DEFECT_FAIL = 3

// Inspection resolve result
export const INSPECTION_NONE_RESOLVED = 1
export const INSPECTION_RESOLVED = 2
export const INSPECTION_NOT_RESOLVED = 3

export const PUBLIC_STATUS_ENABLED = '1';
export const PUBLIC_STATUS_DISABLED = '2';


export const RGC_STATUS_USED = '1';
export const RGC_STATUS_NOT_USED = '2';
export const RGC_STATUS_EXPIRED = '3';

export const RGC_STATUS = [
    {value: RGC_STATUS_USED, label: 'Used'},
    {value: RGC_STATUS_NOT_USED, label: 'Not used'},
    {value: RGC_STATUS_EXPIRED, label: 'Expired'},
]

export const FOLLOW_STATUS = [
    {value: '1', label: 'Enrolled'},
    {value: '2', label: 'Unenrolled'},
    {value: '3', label: 'Expired'},
]

export const STOP_ORDER = [
    {value: '1', label: 'Regular'},
    {value: '2', label: 'Reverse'},
]

export const STUDENT_ASSIGNMENTS = [
    {value: '1', label: 'Duplicate from Original Route'},
    {value: '2', label: 'Do not duplicate'},
]

// Lost Card Status
export const LOST_CARD_REPORTED = 1
export const LOST_CARD_PRINTING = 2
export const LOST_CARD_HANDED_OUT = 3
export const LOST_CARD_NOT_LOST = 4

export const LOST_CARD_STATUS = [
    {value: '1', label: 'Reported'},
    {value: '2', label: 'Printing'},
    {value: '3', label: 'Handed out'},
    {value: '4', label: 'Not lost'},
]

export const SCHEDULED_TYPE = [
    {value: '1', label: 'Scheduled Pudo'},
    {value: '2', label: 'Unscheduled Pudo'},
]

export const ACTION_TYPE = [
    {value: '1', label: 'Archived'},
    {value: '2', label: 'Lost'},
]


// Gallery Type
export const GALLERY_BUS = 1
export const GALLERY_DRIVER = 2
export const GALLERY_STUDENT = 3



// Skip Request Status
export const SKIP_REQUEST_SCHEDULED = 1
export const SKIP_REQUEST_EXECUTED = 2
export const SKIP_REQUEST_CANCELLED = 3
export const SKIP_REQUEST_RESCHEDULED = 4
export const SKIP_REQUEST_COLOR = {
    1: 'inactive',
    2: 'active',
    3: 'archived',
    4: 'inactive',
}
export const SKIP_REQUEST_STATUSES = [
    {value: SKIP_REQUEST_SCHEDULED, label: 'Scheduled', status: 'inactive'},
    {value: SKIP_REQUEST_EXECUTED, label: 'Executed', status: 'active'},
    {value: SKIP_REQUEST_CANCELLED, label: 'Cancelled', status: 'archived'},
    {value: SKIP_REQUEST_RESCHEDULED, label: 'Rescheduled', status: 'inactive'},
]

// Skip Request By
export const SKIP_REQUEST_BY_GUARDIAN = 1
export const SKIP_REQUEST_BY_STUDENT = 2
export const SKIP_REQUEST_BY = [
    {value: SKIP_REQUEST_BY_GUARDIAN, label: 'Guardian'},
    {value: SKIP_REQUEST_BY_STUDENT, label: 'Student'},
]

// 
export const SPECIAL_NEED = [
    {value: '1', label: 'None'},
    {value: '2', label: 'Yes'},
    {value: '3', label: 'No'},
]

// Bus Type
export const BUS_TYPE_NORMAL = '1'
export const BUS_TYPE_SPED = '2'
export const BUS_TYPES = [
    {value: BUS_TYPE_NORMAL, label: 'Normal'},
    {value: BUS_TYPE_SPED, label: 'SPED'},
]